// extracted by mini-css-extract-plugin
module.exports = {"row":"PaymentStatusAmount_row__H7VfP","statusWrapper":"PaymentStatusAmount_statusWrapper__1bM3X","amount":"PaymentStatusAmount_amount__2iHmJ"};